.DiceboundModal {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: rgba(34, 34, 34, 0.5);
}
.DiceboundModal .Header,
.DiceboundModal .Footer {
  font-size: 0.5em;
  text-align: center;
  font-family: var(--header-font);
  text-stroke: 0.2em #111111;
  -ms-text-stroke: 0.2em #111111;
  -moz-text-stroke: 0.2em #111111;
  -webkit-text-stroke: 0.2em #111111;
  paint-order: stroke fill;
  margin-top: 2em;
  margin-bottom: 2em;
}
.DiceboundModal .Header .BigText,
.DiceboundModal .Footer .BigText {
  font-size: 1.3em;
  line-height: 1em;
}
.DiceboundModal .Header .SmallText,
.DiceboundModal .Footer .SmallText {
  font-size: 0.75em;
  line-height: 1em;
}
.DiceboundModal .Header .SmallText[isHoverable]:hover,
.DiceboundModal .Footer .SmallText[isHoverable]:hover {
  color: hotpink;
}
.DiceboundModal .UnitsSection {
  display: flex;
  align-items: center;
  justify-content: center;
}
.DiceboundModal .UnitsSection .Or {
  text-stroke: 0.2em #111111;
  -ms-text-stroke: 0.2em #111111;
  -moz-text-stroke: 0.2em #111111;
  -webkit-text-stroke: 0.2em #111111;
  paint-order: stroke fill;
}
.DiceboundModal .UnitsSection .Unit {
  font-size: 0.75em;
  margin: 0em 0.2em;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  transition-duration: 0.25s;
  transition-property: opacity, filter, transform;
}
.DiceboundModal .UnitsSection .Unit .Thumbnail {
  width: 1em;
  height: 1em;
  position: relative;
  margin-top: 0.4em;
}
.DiceboundModal .UnitsSection .Unit .Thumbnail .UnitHealthBar {
  left: 0em;
  right: 0em;
  margin: auto;
  bottom: 0em;
  height: 0.15em;
  max-width: 0.66em;
  position: absolute;
}
.DiceboundModal .UnitsSection .Unit .DraftButton {
  margin-top: 1.4em;
  width: 8em;
  height: 1.5em;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--editor-font);
}
.DiceboundModal .UnitsSection .Unit .DraftButton span {
  font-size: 1rem;
  line-height: 1rem;
}
.DiceboundModal .UnitsSection .Unit .DraftableDice .Number {
  font-size: 0.25em;
  text-align: center;
  margin-bottom: 0.25em;
  text-stroke: 0.35em #111111;
  -ms-text-stroke: 0.35em #111111;
  -moz-text-stroke: 0.35em #111111;
  -webkit-text-stroke: 0.35em #111111;
  paint-order: stroke fill;
}
.DiceboundModal .UnitsSection .Unit .DraftableDice .Description,
.DiceboundModal .UnitsSection .Unit .DraftableDice .Name {
  font-size: 0.5em;
  text-align: center;
  margin-bottom: 0.5em;
  text-stroke: 0.35em #111111;
  -ms-text-stroke: 0.35em #111111;
  -moz-text-stroke: 0.35em #111111;
  -webkit-text-stroke: 0.35em #111111;
  paint-order: stroke fill;
  height: 1em;
  line-height: 1em;
  position: relative;
}
.DiceboundModal .UnitsSection .Unit .DraftableDice .Description span,
.DiceboundModal .UnitsSection .Unit .DraftableDice .Name span {
  left: -3em;
  right: -3em;
  position: absolute;
  text-align: center;
}
.DiceboundModal .UnitsSection .Unit .DraftableDice .DiceLayout {
  background-color: transparent;
  border: none;
  font-size: 1em;
}
.DiceboundModal .UnitsSection .Unit .DraftableDice .DiceLayout .Dice .DiceFace {
  border-style: solid;
  border-width: 0.1em;
  border-radius: 0.1em;
  border-color: #111111;
}
.DiceboundModal .UnitsSection .Unit .EquippedDice {
  font-size: 0.5em;
}
.DiceboundModal .UnitsSection .Unit .EquippableDice {
  margin-top: 0.2em;
}
.DiceboundModal .UnitsSection .Unit .EquippableDice .Description {
  font-size: 0.25em;
  text-align: center;
  font-family: var(--header-font);
  text-stroke: 0.35em #111111;
  -ms-text-stroke: 0.35em #111111;
  -moz-text-stroke: 0.35em #111111;
  -webkit-text-stroke: 0.35em #111111;
  paint-order: stroke fill;
}
.DiceboundModal .UnitsSection .Unit .Status {
  left: 0em;
  right: 0em;
  bottom: -1.4em;
  position: absolute;
  line-height: 1em;
  text-align: center;
  font-size: 0.3em;
  text-stroke: 0.2em #111111;
  -ms-text-stroke: 0.2em #111111;
  -moz-text-stroke: 0.2em #111111;
  -webkit-text-stroke: 0.2em #111111;
  paint-order: stroke fill;
  opacity: 0;
  transition-duration: 0.5s;
  transition-property: opacity;
}
.DiceboundModal .UnitsSection .Unit[isLockedIn] {
  filter: grayscale(2);
  opacity: 0.75;
  transform: translateY(-0.5em);
}
.DiceboundModal .UnitsSection .Unit[isLockedIn] .Label {
  display: none;
}
.DiceboundModal .UnitsSection .Unit[isLockedIn] .Status {
  opacity: 1;
}
.DiceboundModal .DoneSection {
  padding-top: 0.5em;
  text-align: center;
}
.DiceboundModal .DoneSection button {
  font: inherit;
  font-size: 0.5em;
  padding: 0em 1em;
}
.DiceboundModal .DoneSection button:not([isEnabled]) {
  opacity: 0.5;
}
.DiceboundModal .DoneSection button:not(:last-child) {
  margin-right: 0.5em;
}
.DiceboundModal .LootablePassiveSection {
  width: 6em;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.DiceboundModal .LootablePassiveSection .LootablePassive {
  width: 100%;
  position: relative;
  background-color: rgba(0, 0, 0, 0.2);
}
.DiceboundModal .LootablePassiveSection .LootablePassive .Unit {
  top: 0em;
  width: 1em;
  right: 0.2em;
  bottom: 0em;
  position: absolute;
}
.DiceboundModal .LootablePassiveSection .LootablePassive .Unit .UnitSprite {
  top: 0em;
  bottom: 0em;
  margin: auto;
}
.DiceboundModal .LootablePassiveSection .LootablePassive .Summary {
  font-size: 0.5em;
  padding: 0.618em;
}
.DiceboundModal .LootablePassiveSection .LootablePassive .Summary .Title {
  font-size: 1em;
}
.DiceboundModal .LootablePassiveSection .LootablePassive .Summary .Description {
  font-size: 0.5em;
}
.DiceboundModal .LootablePassiveSection .LootablePassive:not(:last-child) {
  margin-bottom: 0.2em;
}
.DiceboundModal .LootablePassiveSection .LootablePassive:hover {
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.5);
}
.LootModal {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: rgba(34, 34, 34, 0.5);
}
.LootModal .Header,
.LootModal .Footer {
  font-size: 0.5em;
  text-align: center;
  font-family: var(--header-font);
  text-stroke: 0.2em #111111;
  -ms-text-stroke: 0.2em #111111;
  -moz-text-stroke: 0.2em #111111;
  -webkit-text-stroke: 0.2em #111111;
  paint-order: stroke fill;
  margin-top: 2em;
  margin-bottom: 2em;
}
.LootModal .Header .BigText,
.LootModal .Footer .BigText {
  font-size: 1.3em;
  line-height: 1em;
}
.LootModal .Header .SmallText,
.LootModal .Footer .SmallText {
  font-size: 0.75em;
  line-height: 1em;
}
.LootModal .Header .SmallText[isHoverable]:hover,
.LootModal .Footer .SmallText[isHoverable]:hover {
  color: hotpink;
}
.LootModal .UnitsSection {
  display: flex;
  align-items: center;
  justify-content: center;
}
.LootModal .UnitsSection .Or {
  text-stroke: 0.2em #111111;
  -ms-text-stroke: 0.2em #111111;
  -moz-text-stroke: 0.2em #111111;
  -webkit-text-stroke: 0.2em #111111;
  paint-order: stroke fill;
}
.LootModal .UnitsSection .Unit {
  font-size: 0.75em;
  margin: 0em 0.2em;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  transition-duration: 0.25s;
  transition-property: opacity, filter, transform;
}
.LootModal .UnitsSection .Unit .Thumbnail {
  width: 1em;
  height: 1em;
  position: relative;
  margin-top: 0.4em;
}
.LootModal .UnitsSection .Unit .Thumbnail .UnitHealthBar {
  left: 0em;
  right: 0em;
  margin: auto;
  bottom: 0em;
  height: 0.15em;
  max-width: 0.66em;
  position: absolute;
}
.LootModal .UnitsSection .Unit .DraftButton {
  margin-top: 1.4em;
  width: 8em;
  height: 1.5em;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--editor-font);
}
.LootModal .UnitsSection .Unit .DraftButton span {
  font-size: 1rem;
  line-height: 1rem;
}
.LootModal .UnitsSection .Unit .DraftableDice .Number {
  font-size: 0.25em;
  text-align: center;
  margin-bottom: 0.25em;
  text-stroke: 0.35em #111111;
  -ms-text-stroke: 0.35em #111111;
  -moz-text-stroke: 0.35em #111111;
  -webkit-text-stroke: 0.35em #111111;
  paint-order: stroke fill;
}
.LootModal .UnitsSection .Unit .DraftableDice .Description,
.LootModal .UnitsSection .Unit .DraftableDice .Name {
  font-size: 0.5em;
  text-align: center;
  margin-bottom: 0.5em;
  text-stroke: 0.35em #111111;
  -ms-text-stroke: 0.35em #111111;
  -moz-text-stroke: 0.35em #111111;
  -webkit-text-stroke: 0.35em #111111;
  paint-order: stroke fill;
  height: 1em;
  line-height: 1em;
  position: relative;
}
.LootModal .UnitsSection .Unit .DraftableDice .Description span,
.LootModal .UnitsSection .Unit .DraftableDice .Name span {
  left: -3em;
  right: -3em;
  position: absolute;
  text-align: center;
}
.LootModal .UnitsSection .Unit .DraftableDice .DiceLayout {
  background-color: transparent;
  border: none;
  font-size: 1em;
}
.LootModal .UnitsSection .Unit .DraftableDice .DiceLayout .Dice .DiceFace {
  border-style: solid;
  border-width: 0.1em;
  border-radius: 0.1em;
  border-color: #111111;
}
.LootModal .UnitsSection .Unit .EquippedDice {
  font-size: 0.5em;
}
.LootModal .UnitsSection .Unit .EquippableDice {
  margin-top: 0.2em;
}
.LootModal .UnitsSection .Unit .EquippableDice .Description {
  font-size: 0.25em;
  text-align: center;
  font-family: var(--header-font);
  text-stroke: 0.35em #111111;
  -ms-text-stroke: 0.35em #111111;
  -moz-text-stroke: 0.35em #111111;
  -webkit-text-stroke: 0.35em #111111;
  paint-order: stroke fill;
}
.LootModal .UnitsSection .Unit .Status {
  left: 0em;
  right: 0em;
  bottom: -1.4em;
  position: absolute;
  line-height: 1em;
  text-align: center;
  font-size: 0.3em;
  text-stroke: 0.2em #111111;
  -ms-text-stroke: 0.2em #111111;
  -moz-text-stroke: 0.2em #111111;
  -webkit-text-stroke: 0.2em #111111;
  paint-order: stroke fill;
  opacity: 0;
  transition-duration: 0.5s;
  transition-property: opacity;
}
.LootModal .UnitsSection .Unit[isLockedIn] {
  filter: grayscale(2);
  opacity: 0.75;
  transform: translateY(-0.5em);
}
.LootModal .UnitsSection .Unit[isLockedIn] .Label {
  display: none;
}
.LootModal .UnitsSection .Unit[isLockedIn] .Status {
  opacity: 1;
}
.LootModal .DoneSection {
  padding-top: 0.5em;
  text-align: center;
}
.LootModal .DoneSection button {
  font: inherit;
  font-size: 0.5em;
  padding: 0em 1em;
}
.LootModal .DoneSection button:not([isEnabled]) {
  opacity: 0.5;
}
.LootModal .DoneSection button:not(:last-child) {
  margin-right: 0.5em;
}
.LootModal .LootablePassiveSection {
  width: 6em;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.LootModal .LootablePassiveSection .LootablePassive {
  width: 100%;
  position: relative;
  background-color: rgba(0, 0, 0, 0.2);
}
.LootModal .LootablePassiveSection .LootablePassive .Unit {
  top: 0em;
  width: 1em;
  right: 0.2em;
  bottom: 0em;
  position: absolute;
}
.LootModal .LootablePassiveSection .LootablePassive .Unit .UnitSprite {
  top: 0em;
  bottom: 0em;
  margin: auto;
}
.LootModal .LootablePassiveSection .LootablePassive .Summary {
  font-size: 0.5em;
  padding: 0.618em;
}
.LootModal .LootablePassiveSection .LootablePassive .Summary .Title {
  font-size: 1em;
}
.LootModal .LootablePassiveSection .LootablePassive .Summary .Description {
  font-size: 0.5em;
}
.LootModal .LootablePassiveSection .LootablePassive:not(:last-child) {
  margin-bottom: 0.2em;
}
.LootModal .LootablePassiveSection .LootablePassive:hover {
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.5);
}
.LootModal .SkipButton {
  margin-top: 1em;
  display: inline-block;
  background-color: rgba(74, 92, 108, 0.8);
}
.LootModal .SkipButton .Text {
  padding: 0em 1em;
  font-size: 0.5em;
}
.LootModal .SkipButton:not([isEnabled]) {
  opacity: 0.5;
}
.LootModal .SkipButton[isEnabled] {
  opacity: 0.8;
}
.LootModal .SkipButton[isEnabled]:active,
.LootModal .SkipButton[isEnabled]:hover {
  opacity: 1;
}
.EquipmentScreen {
  display: flex;
  width: 100%;
  height: 100%;
  background-color: rgba(74, 92, 108, 0.8);
}
.EquipmentScreen .ItemsSection {
  width: 6em;
  background-color: rgba(74, 92, 108, 0.8);
  display: flex;
  flex-direction: column;
}
.EquipmentScreen .ItemsSection .SelectedItem {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
.EquipmentScreen .ItemsSection .Button {
  height: 2em;
  position: relative;
  font-size: 0.6em;
}
.EquipmentScreen .ItemsSection .Button .SkipButton,
.EquipmentScreen .ItemsSection .Button .ContinueButton {
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  position: absolute;
  transition-duration: 0.2s;
  transition-property: opacity;
}
.EquipmentScreen .ItemsSection .Button .SkipButton:not([isVisible]),
.EquipmentScreen .ItemsSection .Button .ContinueButton:not([isVisible]) {
  opacity: 0;
}
.EquipmentScreen .ItemsSection .Button .SkipButton[isVisible],
.EquipmentScreen .ItemsSection .Button .ContinueButton[isVisible] {
  opacity: 0.8;
}
.EquipmentScreen .ItemsSection .Button .SkipButton[isVisible]:hover,
.EquipmentScreen .ItemsSection .Button .ContinueButton[isVisible]:hover {
  cursor: pointer;
  background-color: #2D2D2A;
}
.EquipmentScreen .SelectedItemCursor {
  width: 1em;
  height: 1em;
  z-index: 100;
  position: fixed;
  margin-top: -0.5em;
  margin-left: -0.5em;
  pointer-events: none;
  display: none;
}
.EquipmentScreen .SelectedItemCursor[hasSelected] {
  display: block;
}
